export const tr = {
    close: 'Kapat',
    download: 'Dosya indir',
    'error-message': 'Hata oluştu. Lütfen, daha sonra tekrar deneyin.',
    'export-to-excel': "Excel'e veri aktarımı",
    'pay-not-allowed-cpm':
        'Medya kampanyalarının ödenmesi için ayrı bir fatura kesilir. Bu kampanyalar diğer kampanyalarla birlikte ödenemez.',
    'pay-not-allowed-deals':
        'İşlem kampanyalarının ödenmesi için ayrı bir fatura kesilir. Bu kampanyalar diğer kampanyalarla birlikte ödenemez.'
};
